import { createFileRoute } from "@tanstack/react-router";
import CmoComparisonArticle, {
  COMPARISON_DESCRIPTION,
  COMPARISON_PATH,
  COMPARISON_SCHEMA,
  COMPARISON_TITLE,
} from "@/pages/CmoComparisonArticle";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/blog/cmo-externalise-vs-agence-vs-recrutement")({
  head: () => {
    const base = pageHead({ path: COMPARISON_PATH, title: COMPARISON_TITLE, description: COMPARISON_DESCRIPTION, enPath: null });
    return {
      ...base,
      meta: [
        ...(base.meta ?? []),
        { property: "og:type", content: "article" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      scripts: COMPARISON_SCHEMA.map((s) => ({ type: "application/ld+json", children: JSON.stringify(s) })),
    };
  },
  component: CmoComparisonArticle,
});
